<p-card>
  @if (isMeterDataLoading) {
    <div class="flex justify-content-center align-items-center">
      <p-progress-spinner
        ariaLabel="loading"
        class="w-2rem h-2rem"
      />
    </div>
  } @else if (isMeterDataEmpty) {
    <div class="flex justify-content-center align-items-center p-4">
      <p>{{ 'noIDPContractMsg' | translate }}</p>
    </div>
  } @else {
    <div class="flex justify-content-between align-items-start pb-3">
      <h3 class="text-xl font-normal m-0">
        {{ selectedContractRange }}
        <span class="block m-0 p-0 text-sm text-600"> {{ selectedPeriodLabel }} </span>
      </h3>
    </div>
    <p-card>
      <p-meterGroup
        labelPosition="start"
        labelOrientation="vertical"
        [value]="[{ value: pagesExtractedTotal, color: meterColor }]"
        [max]="yearlyPageExtractionQuota || 1"
      >
        <ng-template
          #label
          let-totalPercent="totalPercent"
        >
          @if (hasExceededQuota) {
            <div class="flex justify-content-start flex-wrap">
              <span class="text-left">
                <i class="fa-solid fa-circle-exclamation mr-1 text-red-600"></i>
                {{ 'pageLimitExceedsMsg' | translate: { quota: yearlyPageExtractionQuota } }}
              </span>
            </div>
          } @else {
            <div class="flex justify-content-end flex-wrap">
              <span class="text-right">{{ meterGrouptotalPercent }}%</span>
            </div>
          }
        </ng-template>
      </p-meterGroup>
      <p class="p-0 m-0 mt-3 text-900">
        <span [ngClass]="{ 'text-red-600': hasExceededQuota }"> {{ pagesExtractedTotal }} </span>/{{
          yearlyPageExtractionQuota
        }}
      </p>
    </p-card>
  }
</p-card>
